import { Firebase } from '@/api/firebase';

import { actions, mutations } from './channel.d';
import ChatDefs from '../chat/chat.d';
import TripDefs from '../trip/trip.d';
import UserDefs from '../user/user.d';

const FirebaseDatabase = Firebase.getFirebaseDatabase();
const ALL_CHANNELS = FirebaseDatabase.ref('all_channels');
export default {
  /**
   * Set Current Channel
   */
  [actions.initializeCurrentChannel](context, channelId) {
    return new Promise((resolve, reject) => {
      ALL_CHANNELS.child(channelId).once('value', function(snapshot) {
        let channel = snapshot.val();

        if (!channel) {
          reject('Unable to fetch channel info.');
        } else {
          channel.channelUrl = channel.channel.channel_url;
          context.commit(mutations.setCurrentChannel, channel);
          resolve(channel);
        }
      });
    });
  },

  /**
   * Join Channel to access the user's information
   */
  [actions.joinChannel]: async function(
    { dispatch },
    { channel: { channel_url }, sender: { user_id } }
  ) {
    const config = { root: true };

    await dispatch(`Chat/${ChatDefs.actions.leaveChannel}`, null, config);
    await dispatch(
      `Chat/${ChatDefs.actions.enterChannel}`,
      channel_url,
      config
    );
    await dispatch(actions.initializeCurrentChannel, channel_url);
    await dispatch(`User/${UserDefs.actions.getUser}`, user_id, config);
    await dispatch(
      `Trip/${TripDefs.actions.getRestaurantBooking}`,
      user_id,
      config
    );
  },

  /**
   * Set initial own channel list
   */
  [actions.setOwnChannels](context, channels) {
    return context.commit(mutations.setOwnChannels, channels);
  },

  [actions.pickChannel]: async function({
    commit,
    dispatch,
    state,
    rootState
  }) {
    await dispatch(
      'Chat/updateCustomType',
      { customType: 'active' },
      { root: true }
    );

    let { channelUrl } = state.currentChannel;
    let { currentConcierge } = rootState.Concierge;
    let channelObject = await ALL_CHANNELS.child(channelUrl).once('value');
    if (channelObject) {
      channelObject = channelObject.val();
      channelObject.channel.custom_type = 'active';
      channelObject.status = 'active';
      channelObject.agentId = currentConcierge.agentId;

      commit(mutations.setCurrentChannelStatus, 'active');
      commit(mutations.updateCurrentChannel, {
        key: 'agentId',
        value: currentConcierge.agentId
      });
      await ALL_CHANNELS.child(channelUrl).update(channelObject);
    }
  },

  [actions.transferChannel]: async function(
    { dispatch, state, rootState },
    payload
  ) {
    let { currentConcierge } = rootState.Concierge;

    if (payload.conciergeId !== currentConcierge.agentId) {
      await dispatch(
        'Chat/updateCustomType',
        { customType: 'active' },
        { root: true }
      );

      let { channelUrl } = state.currentChannel;
      let channelObject = await ALL_CHANNELS.child(channelUrl).once('value');

      if (channelObject) {
        channelObject = channelObject.val();
        channelObject.channel.custom_type = 'active';
        channelObject.status = 'active';
        channelObject.agentId = payload.conciergeId;
        channelObject.lastAgentId = currentConcierge.agentId;

        await ALL_CHANNELS.child(channelUrl).update(channelObject);
      }
    }
  },

  [actions.leaveChannel]: async function({ commit, dispatch, state }) {
    await dispatch(
      'Chat/updateCustomType',
      { customType: 'archived' }, // TODO: Set to 'archived' on production
      { root: true }
    );

    let { channelUrl, agentId } = state.currentChannel;
    let channelObject = await ALL_CHANNELS.child(channelUrl).once('value');

    if (channelObject) {
      channelObject = channelObject.val();
      channelObject.lastAgentId = agentId;
      channelObject.channel.custom_type = 'archived'; // TODO: Set to 'archived' on production
      channelObject.status = 'archived'; // TODO: Set to 'archived' on production
      channelObject.agentId = null;

      commit(mutations.setCurrentChannelStatus, 'archived');
      await ALL_CHANNELS.child(channelUrl).update(channelObject);
    }
  }
};
